import { render, staticRenderFns } from "./jobStressAssessmentResultDetail.vue?vue&type=template&id=2c31773d"
import script from "./jobStressAssessmentResultDetail.vue?vue&type=script&lang=js"
export * from "./jobStressAssessmentResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c31773d')) {
      api.createRecord('2c31773d', component.options)
    } else {
      api.reload('2c31773d', component.options)
    }
    module.hot.accept("./jobStressAssessmentResultDetail.vue?vue&type=template&id=2c31773d", function () {
      api.rerender('2c31773d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/jss/jobStressAssessmentResultDetail.vue"
export default component.exports